<template>
  <file-pond
    ref="fpond"
    :name="name"
    :label-idle="$t('click or drop files here')"
    v-bind:allow-multiple="allow_multiple"
    v-bind:allow-revert="allow_revert"
    v-bind:server="{
      url: api_host,
      timeout: enterprise_setup.upload_timeout,
      process: {
        url: url,
        method: 'POST',
        headers: {
          'x-access-token': token_session,
        },
        withCredentials: false,
      },
    }"
    v-on:error="filepond_error"
    v-on:processfile="filepond_process"
  />
</template>

<script>
import {
  enterprise_setup,
  api_host,
  local_api,
  error_toast,
  success_toast,
} from "@/utils";
import "filepond/dist/filepond.min.css";
import vueFilePond from "vue-filepond";
const FilePond = vueFilePond();

export default {
  name: "FileUploader",
  components: { FilePond },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: {
    allow_multiple: {
      type: Boolean,
      default: false,
    },
    allow_revert: {
      type: Boolean,
      default: false,
    },
    url: String,
    name: String,
  },
  data() {
    return {
      api_host: api_host,
    };
  },
  methods: {
    filepond_error(err) {
      this.$emit("error", err);
    },
    filepond_process(event, inst) {
      let vm = this;
      console.log("event", event);
      console.log("inst", inst);
      // let x1 = this.$refs.pond;
      // console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) {
          let err = r.error;
          if (err.type && err.type == "NOT_ALLOWED") {
            window.jQuery("body").toast({
              showProgress: "bottom",
              classProgress: "blue",
              title: vm.$t("resource not allowed"),
              message:
                vm.$t("do you want to request this permission?") +
                ` [${err.resource}]`,
              classActions: "basic left",
              actions: [
                {
                  text: vm.$t("yes"),
                  class: "olive",
                  click: function () {
                    vm.requestPermission(err.resource);
                  },
                },
              ],
            });
          } else {
            console.log(err);
          }
        } else this.$emit("uploaded", r.data);
        // x1.removeFiles().then((r) => {
        //   console.log(r);
        // });
      }
    },
    requestPermission(resource) {
      let vm = this;
      local_api(vm, "post", "/system/do-request-resource-permission", {
        r: resource,
      })
        .then(() => {
          vm.reload_session(vm);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    reload_session() {
      let vm = this;
      local_api(vm, "post", "/user/do-reload-session", {})
        .then(() => {
          success_toast(vm.$t("session reloaded"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    clear() {
      let vm = this;
      // console.log("clearing");
      vm.$refs.fpond.removeFiles();
    },
  },
};
</script>
